import React from 'react';

export function DownArrowSVG ({ customStroke, className = '' }) {
    const stroke = customStroke || '#F04006';
    return (
        <span className={className}>
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L13 1" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>

        </span>
    );
}
